if (!customElements.get('collection-subcategory-tiles')) {
  customElements.define(
    'collection-subcategory-tiles',
    class CollectionSubcategoryTiles extends HTMLElement {
      viewport = null;
      prevBtn = null;
      nextBtn = null;
      onScrollBound = null;
      onResizeBound = null;
      viewportResizeObserver = null;

      connectedCallback() {
        this.viewport = this.querySelector('.collection-subcategory-tiles__viewport');
        this.prevBtn = this.querySelector('.collection-subcategory-tiles__nav--prev');
        this.nextBtn = this.querySelector('.collection-subcategory-tiles__nav--next');
        if (!this.viewport || !this.prevBtn || !this.nextBtn) {
          return;
        }

        this.onScrollBound = () => this.updateNavState();
        this.onResizeBound = () => this.updateNavState();
        this.viewport.addEventListener('scroll', this.onScrollBound, { passive: true });
        window.addEventListener('resize', this.onResizeBound, { passive: true });
        this.prevBtn.addEventListener('click', this.onPrevClick);
        this.nextBtn.addEventListener('click', this.onNextClick);

        if (typeof ResizeObserver !== 'undefined') {
          this.viewportResizeObserver = new ResizeObserver(() => this.updateNavState());
          this.viewportResizeObserver.observe(this.viewport);
        }

        this.updateNavState();
        requestAnimationFrame(() => this.updateNavState());
      }

      disconnectedCallback() {
        this.viewportResizeObserver?.disconnect();
        this.viewportResizeObserver = null;
        if (this.viewport && this.onScrollBound) {
          this.viewport.removeEventListener('scroll', this.onScrollBound);
        }
        if (this.onResizeBound) {
          window.removeEventListener('resize', this.onResizeBound);
        }
        this.prevBtn?.removeEventListener('click', this.onPrevClick);
        this.nextBtn?.removeEventListener('click', this.onNextClick);
      }

      onPrevClick = () => {
        this.scrollByDirection(-1);
      };

      onNextClick = () => {
        this.scrollByDirection(1);
      };

      scrollByDirection(direction) {
        const amount = this.viewport.clientWidth * direction;
        this.viewport.scrollBy({ left: amount, behavior: 'smooth' });
      }

      setNavHidden(hidden) {
        const hiddenClass = 'collection-subcategory-tiles__nav--hidden';
        for (const btn of [this.prevBtn, this.nextBtn]) {
          btn.classList.toggle(hiddenClass, hidden);
          btn.hidden = hidden;
          btn.classList.remove('is-disabled');
          if (hidden) {
            btn.disabled = true;
            btn.setAttribute('aria-hidden', 'true');
          } else {
            btn.disabled = false;
            btn.removeAttribute('aria-hidden');
          }
        }
      }

      updateNavState() {
        const tileCount = this.querySelectorAll('.collection-subcategory-tiles__tile').length;
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const maxTilesWithoutNav = isMobile ? 2 : 5;
        const hideByCount = tileCount <= maxTilesWithoutNav;

        const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
        const maxScroll = Math.max(0, scrollWidth - clientWidth);
        const epsilon = 2;
        const noOverflow = maxScroll <= epsilon;

        const hideNav = hideByCount || noOverflow;

        if (hideNav) {
          this.setNavHidden(true);
          return;
        }

        this.setNavHidden(false);

        const atStart = scrollLeft <= epsilon;
        const atEnd = scrollLeft >= maxScroll - epsilon;

        this.prevBtn.classList.toggle('is-disabled', atStart);
        this.nextBtn.classList.toggle('is-disabled', atEnd);
        this.prevBtn.disabled = atStart;
        this.nextBtn.disabled = atEnd;
      }
    },
  );
}